'use client'

// src/api/queries/image.ts
var IMAGE_QUERY = `
title
sys{
  id
  publishedAt
}
url
width
height
contentType
`;

export {
  IMAGE_QUERY
};
//# sourceMappingURL=chunk-AFUSNP5S.mjs.map